import {Activity} from '../common/types/activityArea'
import {GQL_Activity} from '../generated/graphql'

export const transformActivity = (activity: GQL_Activity): Activity => ({
  code: activity.code,
})
